module.exports = __webpack_public_path__ + "static/img/micron.9fffab2.png";